var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXeuBluePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.13504C0 0.287204 0.988857 -0.175952 1.64018 0.36682L11.0781 8.23178C11.5579 8.63157 11.5579 9.36843 11.0781 9.76822L1.64018 17.6332C0.988855 18.176 0 17.7128 0 16.865V1.13504Z",
    fill: "#02235B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXeuBluePlay);
export default __webpack_public_path__ + "static/media/xeu-blue-play.09ace3713c1a369f472f4af3ee98c3fd.svg";
export { ForwardRef as ReactComponent };